import { Box, useTheme } from "@mui/material";
import { useGlobalStore } from "controller";
import { dayjs } from "utilz";
import { CANCELLED_BANNER_COPY } from "./pricingContent";
import { SubscriptionStatusBanner } from "./SubscriptionStatusBanner";

export const CancelledSubscriptionBanner = () => {
  const theme = useTheme();
  const currentAccessBlockDate = useGlobalStore(
    (state) => state.currentAccessBlockDate,
  );
  const dateFormat = useGlobalStore((state) => state.dateFormat);
  const timezone = useGlobalStore((state) => state.timezone);

  const accessBlockDate = dayjs(currentAccessBlockDate)
    .tz(timezone)
    .format(dateFormat);

  return (
    <SubscriptionStatusBanner
      label={
        <>
          {CANCELLED_BANNER_COPY.beforeDate}{" "}
          <Box
            component="span"
            // DV-14 · semibold date: caption-2's face and weight, without
            // its 0.5px letter-spacing.
            sx={{
              fontFamily: theme.typography["caption-2"].fontFamily,
              fontWeight: theme.typography["caption-2"].fontWeight,
            }}
          >
            {accessBlockDate}
          </Box>
          {CANCELLED_BANNER_COPY.afterDate}
        </>
      }
    />
  );
};
